import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CheckboxModel } from '../../model/checkbox.model';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-menu-drawer',
    templateUrl: './menu-drawer.component.html',
    styleUrls: ['./menu-drawer.component.scss']
})
export class MenuDrawerComponent implements OnInit {
    private menuItems: string[] = [];

    @Input() drawerTextHeight: string = 'auto';
    @Input() set itemsSelected(value: string[]) {
        this.menuItems = value;
        this.explainItems();
    }
    public menuItemSelected: string;
    public isExpand: boolean = true;
    public slideSelected: number;
    public image1: string;
    public image2: string;
    public image3: string;
    public logo: string;

    constructor(private translate: TranslateService,
        private globalService: GlobalService) { 
        }

    ngOnInit() {
        this.slideSelected = 1;
        this.getImages();
    }

    explainItems() {
        if (this.menuItems.length === 1) {
            this.menuItemSelected = this.menuItems[0];
        }
        else {
            this.menuItemSelected = this.menuItems[this.menuItems.length - 1];
        }
    }

    isSelected(item: string) {
        return this.menuItemSelected === item;
    }

    getIndexOfSelectedItem(): number {
        return this.menuItems.indexOf(this.menuItemSelected);
    }

    getPrveious() {
        let index = this.getIndexOfSelectedItem();
        this.menuItemSelected = this.menuItems[index - 1];
    }

    getNext() {
        let index = this.getIndexOfSelectedItem();
        this.menuItemSelected = this.menuItems[index + 1];
    }

    getImages() {
        this.translate.get('drawer.slide 1 image').subscribe(image => {
            this.image1 = image;
        });
        this.translate.get('drawer.slide 2 image').subscribe(image => {
            this.image2 = image;
        });
        this.translate.get('drawer.slide 3 image').subscribe(image => {
            this.image3 = image;
        });
        this.translate.get('drawer.drawer-logo').subscribe(image => {
            this.logo = image;
        });
    }

    onKeydown($event) {
        if ($event.keyCode === 13) {
            $event.preventDefault();
            $event.currentTarget.click();
        }
    }

    isFirefox() {
        return this.globalService.isFirefox();
    }

    isRtl() {
        return this.globalService.isRtl();
    }

    isLongHeader() {
        return this.globalService.isLongHeader();
    }

    public initalizeDrawer() {
        this.slideSelected = 1;
    }
}
